export default {
  groups: [],
  loading: false,
}
